<template>
	<div>
		<div class="nav" :style="{backgroundColor: common_info.header.background.color}">
			<div class="w nav-box">
				<router-link to="/allsort" class="nav-all" :style="{color: common_info.header.font_color}">
					<div class="img-all">
						<span :style="{color: common_info.header.font_color}"></span>
						<span :style="{color: common_info.header.font_color}"></span>
						<span :style="{color: common_info.header.font_color}"></span>
					</div>
					全部商品分类
					<i class="img-xia" :style="{color: common_info.header.font_color}"></i>
				</router-link>
				<ul class="nav-list">
					<li v-for="(item,index) in common_info.header.list" :key="index">
						<!-- 本窗口 -->
						<template v-if="item.open_type == 0">
							<!-- 外部链接 -->
							<template v-if="item.page_url.indexOf('http') != -1">
								<a :href="item.page_url" v-text="item.title" :style="{color: common_info.header.font_color}"></a>
							</template>
							<!-- 内部链接 -->
							<template>
								<router-link :to="item.page_url" v-text="item.title" :style="{color: common_info.header.font_color}"></router-link>
							</template>
						</template>
						<!-- 新窗口 -->
						<template v-else>
							<!-- 外部链接 -->
							<template v-if="item.page_url.indexOf('http') != -1">
								<a :href="item.page_url" target="_blank" v-text="item.title" :style="{color: common_info.header.font_color}"></a>
							</template>
							<!-- 内部链接 -->
							<template>
								<router-link :to="item.page_url" target="_blank" v-text="item.title" :style="{color: common_info.header.font_color}"></router-link>
							</template>
						</template>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				common_info: {
					header: {
						background: {}
					},
				},
			};
		},
		created() {
			this.common.getCommonInfo(this);
		},
		methods: {
			
		}
	};
</script>

<style lang="scss" scoped>
	.nav {
		position: relative;
		height: 40px;
		width: 100%;
		background-color: #fff;
		box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .1);

		.nav-box {
			display: flex;
			height: 40px;
			// align-items: center;
			line-height: 40px;

			.nav-all {
				display: flex;
				align-items: center;
				font-size: 16px;
				font-weight: 600;
				width: 190px;
				padding-left: 20px;
				box-sizing: border-box;

				.img-all {
					width: 14px;
					height: 12px;
					margin-right: 8px;
					vertical-align: middle;

					span {
						display: block;
						margin-top: 3px;
					}

					span:after {
						content: "";
						display: block;
						width: 14px;
						height: 0;
						border-top: 2px solid;
					}

					span:first-child {
						margin-top: 0;
					}
				}

				.img-xia {
					/* width: 9px;
					height: 6px;
					margin-left: 4px;
					vertical-align: middle; */
					content: "";
					width: 0;
					height: 0;
					margin-left: 4px;
					border-top: 4px solid;
					border-right: 4px solid transparent;
					border-left: 4px solid transparent;
				}
			}

			.nav-list {
				display: flex;
				font-weight: 600;
				margin-left: 34px;
				flex-wrap: wrap;
				overflow: hidden;
				flex: 1;

				li {
					margin-right: 40px;

					a {
						font-size: 16px;
						color: #333;
						font-weight: 600;
						display: block;
						cursor: pointer;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						&:hover {
							color: #ff0e25;
						}
					}
				}

				li:last-child {
					margin-right: 0;
				}
			}
		}
	}
</style>
